module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/homes_sukagawa_b-e1aa5bfd51dc6aa573a0a165d4d8242d.jpg";